import React, {useEffect, useRef, useState} from 'react';
import {useGoalComment} from "../../../models/goal-comment/use-goal-comment";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import Table from "../../../system/components/table";
import {useAttachment} from "../../../models/attachment/use-attachment";
import BoxHeader from "../../components/box-header";
import {useTranslate} from "../../../system/useTranslate";
import PageHeaderButton from "../../components/page-header-button";
import {Button} from "primereact/button";
import Icon from "../../../system/components/icon";
import {InputIcon} from "primereact/inputicon";
import {IconField} from "primereact/iconfield";
import {InputText} from "primereact/inputtext";
import UploadDialog from "../components/upload-dialog";
import {useUpdateEffect} from "primereact/hooks";
import FileSidebar from "../components/file-sidebar";

function Files(props) {
    const attachment = useAttachment();
    const {config, workspaceMembershipData} = useSelector((state) => state.app);
    const [attachments, setAttachments] = useState([]);
    const [uploadFileDialogVisible, setUploadFileDialogVisible] = useState(false);
    const [selectedFile, setSelectedFile] = useState(undefined);
    const [file, setFile] = useState(false);
    const navigate = useNavigate();
    const translate = useTranslate();
    const hiddenFileInput = useRef();
    const [searchText, setSearchText] = useState("");

    const filteredAttachments = attachments.filter((item) => {
        const q = searchText.trim().toLowerCase();
        if (!q) return true;

        return (
            (item?.name || "").toLowerCase().includes(q) ||
            (item?.title || "").toLowerCase().includes(q) ||
            (item?.fileName || "").toLowerCase().includes(q)
        );
    });



    useEffect(() => {
        getAttachments()
    }, []);

    useUpdateEffect(()=>{
        if (file){
            setUploadFileDialogVisible(true);
        }
    },[file])

    const getAttachments = async ()=>{
        const _attachmentsData = await attachment.getAttachments(workspaceMembershipData?.workspace?.id, props.projectData?.id)
        const attachmentsWithUploader = (_attachmentsData || []).map((item) => {
            const createdBy = item?.createdBy?.member || item?.createdBy || {};
            const fullName = [createdBy?.firstName, createdBy?.lastName].filter(Boolean).join(" ");

            return {
                ...item,
                uploader: fullName || createdBy?.username || createdBy?.email || "",
            };
        });
        setAttachments(attachmentsWithUploader);
        return attachmentsWithUploader
    }
    const linkAttachments = async (e)=>{
        if (e?.linkTo==="task"){
            if (e.selectedTasks){
                const attachmentsToConnect = e.uploadedData.map(file => ({id: file.id}));
                await Promise.all(
                    e.selectedTasks.map(async selectedTask => {
                        const selectedTaskKey = selectedTask.documentId ?? selectedTask.id;
                        const taskData = props.tasks?.find(item => (
                            String(item.documentId ?? item.id) === String(selectedTaskKey)
                        )) || selectedTask;
                        const result = await props.updateTask?.(taskData, {
                            attachments: {connect: attachmentsToConnect}
                        })
                        if (!result) throw new Error(`attachment-task-link-failed:${selectedTaskKey}`);
                        return result;
                    })
                );
            }
        }
        if (e?.linkTo==="project"){
            await props.updateProject?.(props.projectData, {attachments:{connect:e.uploadedData.map(f=>f.id)}})
        }
        await getAttachments();
    }
    const updateLinkedAttachments = async (e)=>{
        if (e.linkTo==="task"){
            await Promise.all(
                e.selectedTasks?.map(async task => {
                    let result = await props.updateTask?.(task, {attachments:{connect:[{id:e?.fileInfo?.id}]}})

                    return result;
                }),
                e.removedTasks?.map(async task => {
                    let result = await props.updateTask?.(task, {attachments:{disconnect:[{id:e?.fileInfo?.id}]}})

                    return result;
                }),
            );
            await getAttachments();
        }
        if (e.linkTo==="project"){
            let toggleProjectAttachment = e.fileInfo?.related.find(r=>r.id===props.projectData?.id)?"disconnect":"connect"
            let result = await props.updateProject?.(props.projectData, {attachments:{[toggleProjectAttachment]:[{id:e?.fileInfo?.id}]}})
            await getAttachments();
            return result;
        }
    }

    return (
        <div className="h-full min-h-0 flex flex-column overflow-hidden py-3">
            <PageHeaderButton title={translate("project-files")} end={<div className="flex gap-2 align-items-center">
                <IconField className="w-20rem">
                    <InputIcon className="pi pi-search"/>
                    <InputText value={searchText}
                               placeholder={`${translate("search-files")}...`}
                               className="py-2 text-sm w-full"
                               onChange={(e)=>{setSearchText(e.target.value)}}
                    />
                </IconField>
                <Button onClick={()=>{hiddenFileInput.current.click();}} className="text-xs p-2 flex gap-1 h-full" label={translate("upload-new-file")} icon={<Icon icon="mi mi:add" className="text-lg"/>}/>
                <input ref={hiddenFileInput} className="p-hidden" type="file" onChange={(e)=>{const _file = e.target.files[0]; setFile(_file)}}/>
            </div>
            }/>

            <div className="flex-1 min-h-0 overflow-hidden border-1 border-100 border-round-3xl shadow-1 py-3 mt-3 mx-3 surface-50">
                <Table
                    value={filteredAttachments}
                    onRowClick={(item)=>{setSelectedFile(item.value)}}
                    fields={attachment.prepareTable({config, actions:{}}).fields}
                    fieldsConfig={attachment.prepareTable({config, actions:{}}).fieldsConfig}
                    showHeader={false}
                    style={null}
                />
            </div>
            <UploadDialog onSubmit={(e)=>{linkAttachments(e)}} setFile={setFile} payload={{tasks:props.tasks, file, projectDocumentId: props.projectData?.documentId}} visible={uploadFileDialogVisible} onHide={()=>{setUploadFileDialogVisible(false)}}/>
            <FileSidebar onHide={()=>{setSelectedFile(undefined)}} visible={selectedFile!==undefined} payload={{selectedFile:attachments.find(attachment=>selectedFile?.id===attachment.id), tasks:props.tasks, projectData:props.projectData}} onChange={(e)=>{updateLinkedAttachments(e)}}/>
        </div>
    );
}

export default Files;
